import { render, staticRenderFns } from "./material-file-add-or-update.vue?vue&type=template&id=5553227c&"
import script from "./material-file-add-or-update.vue?vue&type=script&lang=js&"
export * from "./material-file-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports